<template>
  <v-app v-bind:class="{ xsOnly: $vuetify.breakpoint.xsOnly }">
    <app-notifications></app-notifications>
    <v-toolbar app fixed height="50" dark primary color="primary" class="main-nav" flat>
      <v-spacer></v-spacer>
      <router-link to="/" tag="div">
        <div class="menu-logo">
          <svg
            width="372"
            height="469"
            viewBox="0 0 372 469"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M371.15 209.001C370.53 241.4 359.116 269.249 336.266 292.407C278.795 350.659 221.378 408.963 163.988 467.3C162.296 469.021 161.471 469.243 159.63 467.391C149.132 456.819 138.486 446.393 127.831 435.973C126.698 434.86 126.607 434.284 127.758 433.077C186.888 370.989 245.944 308.824 305.127 246.785C312.915 238.624 318.21 229.416 319.718 218.231C322.006 201.288 317.118 186.685 304.955 174.585C300.572 170.224 300.572 170.22 296.231 174.623C252.935 218.559 209.634 262.488 166.383 306.471C164.872 308.011 164.166 308.088 162.592 306.511C150.052 293.975 137.43 281.527 124.747 269.129C123.288 267.708 123.47 267.023 124.788 265.684C182.374 207.309 239.927 148.905 297.443 90.4613C298.81 89.0693 299.528 89.0479 300.914 90.4333C312.287 101.777 323.635 113.159 335.198 124.311C352.744 141.229 363.778 161.66 368.759 185.429C370.387 193.184 371.13 201.049 371.15 209.001"
              fill="#ED1B49"
            />
            <path
              d="M209.73 0.189395C223.338 13.6494 236.929 27.1294 250.592 40.544C251.918 41.8467 252.078 42.5161 250.694 43.9667C190.184 107.368 129.715 170.807 69.2652 234.267C51.3332 253.095 50.1825 281.415 66.8172 301.34C72.9505 308.68 80.4665 314.743 87.3545 321.384C97.7225 331.379 108.154 341.301 118.608 351.209C119.664 352.207 119.861 352.724 118.74 353.895C107.218 365.909 95.7545 377.981 84.3185 390.077C83.2518 391.207 82.6598 391.42 81.4238 390.188C65.0758 373.931 48.3638 358.027 32.3518 341.449C14.9118 323.393 4.56917 301.587 1.4025 276.631C-3.0495 241.536 6.23716 210.357 29.2758 183.507C38.3238 172.964 48.5932 163.524 58.3438 153.621C108.146 103.021 157.989 52.4601 207.813 1.88141C208.326 1.36008 208.761 0.756062 209.23 0.189395H209.73Z"
              fill="#ED1B49"
            />
          </svg>
        </div>
      </router-link>
      <v-spacer></v-spacer>
      <div class="menu-nav-icon" @click.stop="rightDrawer = !rightDrawer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.21 255.12">
          <title>Logo</title>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <rect class="line" width="28.35" height="255.12" />
              <rect class="line" x="57.09" width="28.35" height="255.12" />
              <rect class="line" x="114.18" width="28.35" height="255.12" />
              <rect class="line" x="169.77" width="28.35" height="255.12" />
              <rect class="line" x="226.86" width="28.35" height="255.12" />
            </g>
          </g>
        </svg>
      </div>
    </v-toolbar>
    <v-content>
      <router-view />
    </v-content>
    <v-dialog
      v-model="iosInstall"
      width="500"

    >
      <v-card
      color="primary"
      dark>
      <v-container text-xs-center>
        <v-layout row wrap>
      <v-flex xs12>
        <img :src="require('@/assets/appicon.png')" alt="ios icon" width="50px" height="50px"/>
        <p class="display-1 pt-3">Install G4 Claims</p>
        <p class="title pt-3 px-2">Install this application on your home screen for quick and easy access when you're on the go.</p>
      </v-flex>
        </v-layout>
      </v-container>

        <v-card-actions class="lighten">
          <v-spacer></v-spacer>
          <p class="ios-share">Just tap <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path d="M488.41 11.26c-6.89 1.82-18.86 12.77-81.31 75.43-70.77 70.77-73.4 73.61-75.84 83.54-7.3 31.63 22.3 55.36 51.71 41.57 4.87-2.43 21.7-17.44 42.58-38.53 18.86-19.06 35.08-34.67 35.89-34.67.81 0 1.82 108.28 2.03 240.69l.61 240.89 4.66 8.11c7.1 12.37 16.83 18.04 30.62 18.25 14.8 0 26.16-6.89 32.44-19.67l4.26-8.92V136.17l38.12 38.53c35.89 36.5 38.53 38.73 48.26 40.96 18.66 4.26 35.89-4.05 43.6-21.29 4.26-9.33 4.67-15.01 1.62-26.36-1.83-6.9-13.59-19.47-72.39-78.67-38.73-38.73-73-72.19-76.44-74.42-7.91-4.67-20.28-6.29-30.42-3.66z"/><path d="M179.19 259.05c-21.9 6.08-37.51 18.66-46.43 37.72l-5.27 11.15v624.54l4.66 11.56c5.88 14.6 22.1 32.65 35.69 39.74l10.34 5.48 317.74.61c316.73.41 317.74.41 328.89-3.65 12.98-4.87 29.2-18.65 36.29-31.02 12.37-20.88 11.76-1.62 11.15-340.04l-.61-309.22-4.87-9.13c-7.5-14.19-12.37-19.87-23.32-27.37-18.25-12.37-26.76-13.38-105.03-12.77l-69.55.61-9.53 5.48c-15.61 9.33-21.7 27.17-14.8 43.6 4.26 10.14 8.52 14.6 18.25 19.06 7.3 3.45 14.19 3.85 67.32 3.85h59.21l5.68 4.86 5.68 4.87.61 279.01.41 279.21-4.87 4.87-5.07 5.07H499.97c-284.49 0-291.99 0-296.65-3.85l-4.87-3.85V338.98l5.68-4.87 5.68-4.86h116.6l11.15-5.68c29.4-14.8 25.75-54.14-6.08-64.89-9.95-3.49-139.92-3.08-152.29.37z"/></svg>
          below then 'Add to Home Screen'</p>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="pink"  @click="iosInstall = false">Close</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer temporary right v-model="rightDrawer" fixed app dark class="navdrawer">
      <v-list>
        <v-list-tile @click="rightDrawer = !rightDrawer">
          <v-list-tile-action>
            <v-icon>close</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-toolbar flat class="transparent">
        <v-list class="pa-0" style="padding-left:6px;">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="body-2">{{ user.email }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile
          v-for="item in items"
          :key="item.title"
          router
          :to="item.link"
          :exact="item.exact"
          active-class="default-class menu-current"
        >
          <v-list-tile-action>
            <v-icon class="body-4">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="body-2">{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="onLogout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="body-2" data-v-step="menu">Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-bottom-nav :active.sync="bottomNav" :value="true" color="primary" dark app>
      <v-btn to="/documents" color="secondary" flat value="documents">
        <v-icon>note_add</v-icon>
      </v-btn>

      <v-btn to="/help" color="secondary" flat value="help">
        <v-icon>help_outline</v-icon>
      </v-btn>

      <v-btn to="/call" color="secondary" flat value="call">
        <v-icon>call</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-app>
</template>

<script>
import AppNotifications from '@/components/Shared/AppNotifications'
export default {
  components: {
    AppNotifications
  },
  data () {
    return {
      bottomNav: 'documents',
      miniVariant: false,
      rightDrawer: false,
      iosInstall: this.needsToSeePrompt(),
      items: [
        { title: 'Account', icon: 'settings', link: '/account', exact: false }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    }

  },
  watch: {
    user (value) {
      if (value === null || value === undefined) {
        this.$router.push('/sign-in')
      }
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
    },
    needsToSeePrompt () {
      if (navigator.standalone) {
        return false
      }
      return ['iPhone', 'iPad', 'iPod'].includes(navigator.platform)
    }
  }
}
</script>

<style lang="scss">
.menu-logo {
  cursor: pointer;
  transition: background-color 0.3s;
  svg {
    width: 40px;
    height: 40px;
  }
}
.ios-share {
  display: flex;
  align-items: center;
  svg {
    width: 30px;
    height: 30px;
    fill:#007aff;
    margin-bottom:10px;
  }
}
.menu-nav-icon {
  cursor: pointer;
  transform: rotate(90deg);
  svg {
    width: 15px;
    height: 15px;
    rect {
      fill: #fff;
    }
  }
}
.lighten{
  background:#292727;
}

.v-step {
  z-index: 9999;
}
</style>
